exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bigText[data-v-85850c1e]{font-weight:550px;color:#2f4f4f!important}", ""]);

// exports
